import React from 'react';
import { useTranslation } from 'react-i18next';
import { PhoneButtonClickHandler } from '../../BottomPhoneButton/types';
import {
  formatAzerbaijanPhone,
  phoneWithInternationalCode
} from '../../../../utils/helpers/common';
import { PhoneButtonTargetTypeEnum } from '../../../../hooks/useFullPhoneNumbers';
import { ContactBoxLink, ContactLinkText } from './styled';

interface PhonesSectionProps {
  phonesMasked?: string[];
  phonesShown?: string[] | null;
  isAuthor?: boolean;
  stat?: string;
  onClickHandler: PhoneButtonClickHandler;
}

export const PhonesSection: React.FC<PhonesSectionProps> = ({
  onClickHandler,
  phonesShown,
  phonesMasked,
  isAuthor = false,
  stat = 'residence-contact-box--phone'
}) => {
  const { t } = useTranslation();
  const phonesToShow = phonesShown?.length ? phonesShown : phonesMasked;
  const isPhonesVisible = !!phonesShown?.length;

  const getActivateHandler =
    (index: number) => (e: React.SyntheticEvent<HTMLAnchorElement>) => {
      if (!isAuthor && !phonesShown) {
        onClickHandler(index, false)(e, PhoneButtonTargetTypeEnum.contact);
      }
    };

  const getKeyDownHandler =
    (index: number) => (e: React.KeyboardEvent<HTMLAnchorElement>) => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        getActivateHandler(index)(e);
      }
    };

  return (
    <>
      {phonesToShow?.map((phone, i) => {
        const value = phonesShown?.length
          ? phonesShown[i]
          : `phone-${phone}-${i}`;
        const phoneInternationalCode = phoneWithInternationalCode(value);

        return (
          <ContactBoxLink
            key={value}
            href={isPhonesVisible ? `tel:${phoneInternationalCode}` : undefined}
            role={isPhonesVisible ? undefined : 'button'}
            tabIndex={isPhonesVisible ? undefined : 0}
            data-stat={stat}
            data-cy="contact-box--phone"
            onClick={getActivateHandler(i)}
            onKeyDown={isPhonesVisible ? undefined : getKeyDownHandler(i)}
            $isPhonesVisible={isPhonesVisible}
          >
            <ContactLinkText tag="body_1">
              {isPhonesVisible
                ? formatAzerbaijanPhone(phoneInternationalCode)
                : `${t('pages.current_item.buttons.show_phone')} +994 •••`}
            </ContactLinkText>
          </ContactBoxLink>
        );
      })}
    </>
  );
};
